import { type Reducer, combineReducers } from "@reduxjs/toolkit";
import { useContext } from "react";

import * as pulse from "metabase/notifications/pulse/reducers";
import * as qb from "metabase/query_builder/reducers";
import { commonReducers } from "metabase/reducers-common";
import { metabaseReduxContext, useDispatch, useStore } from "metabase/redux";
import { DEFAULT_EMBEDDING_ENTITY_TYPES } from "metabase/redux/embedding-data-picker";
import { getStore } from "metabase/store";
import { reducer as visualizer } from "metabase/visualizer/visualizer.slice";

import { sdkListenerMiddleware } from "./listener-middleware";
import { sdk } from "./reducer";
import type { SdkDispatch, SdkStore } from "./types";

export const sdkReducers = {
  ...commonReducers,
  pulse: combineReducers(pulse),
  qb: combineReducers(qb),
  visualizer,
  sdk,
} as unknown as Record<string, Reducer>;

export const getSdkStore = () =>
  getStore(
    sdkReducers,
    null,
    {
      embed: {
        options: {
          entity_types: DEFAULT_EMBEDDING_ENTITY_TYPES,
        },
      },
      app: {
        isDndAvailable: false,
      },
    },
    [sdkListenerMiddleware.middleware],
  ) as unknown as SdkStore;

export const useSdkDispatch = () => {
  useCheckSdkReduxContext();

  return useDispatch() as SdkDispatch;
};

export const useSdkStore = () => {
  useCheckSdkReduxContext();

  return useStore() as SdkStore;
};

const useCheckSdkReduxContext = () => {
  const context = useContext(metabaseReduxContext);

  if (!context) {
    console.warn(
      // eslint-disable-next-line metabase/no-literal-metabase-strings -- not UI string
      "Cannot find react-redux context. Make sure component or hook is wrapped into MetabaseProvider",
    );
  }
};

export { useSdkSelector } from "./use-sdk-selector";
